<script setup>
import { BugAntIcon, ChatBubbleLeftRightIcon } from '@heroicons/vue/24/outline'
import HeadingTwo from '@/Components/HeadingTwo.vue'
import Paragraph from '@/Components/Paragraph.vue'
</script>

<template>
    <div class="section--width">
        <div class="mx-auto max-w-2xl sm:text-center">
            <HeadingTwo
                class="!mt-0"
                value="Kam dále ?"
            />
        </div>

        <div class="mx-auto mt-5 max-w-lg space-y-4 xl:space-y-16">
            <div class="card flex gap-x-6">
                <div class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-sky-600">
                    <ChatBubbleLeftRightIcon
                        class="size-6 text-white"
                        aria-hidden="true"
                    />
                </div>

                <div>
                    <h3 class="text-base/7 font-semibold text-zinc-800 dark:text-zinc-200">Blog a články</h3>

                    <Paragraph>
                        Podívejte se na naše blogy a články, kde najdete spoustu užitečných informací a tipů, jak zvládnout daňové přiznání.
                    </Paragraph>

                    <p class="mt-4 text-sm/6 font-semibold">
                        <Link
                            :href="route('blogs.index')"
                            class="relative flex items-center rounded-lg border border-cyan-300 bg-cyan-600 px-4 py-2 text-white"
                            aria-label="Přejit na blogy"
                        >
                            Přejit na blogy <span aria-hidden="true">&rarr;</span>
                        </Link>
                    </p>
                </div>
            </div>

            <div class="card flex gap-x-6">
                <div class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-sky-600">
                    <BugAntIcon
                        class="size-6 text-white"
                        aria-hidden="true"
                    />
                </div>

                <div>
                    <h3 class="text-base/7 font-semibold text-zinc-800 dark:text-zinc-200">O nás</h3>

                    <Paragraph> Zjistěte více o nás a našich službách </Paragraph>

                    <p class="mt-4 text-sm/6 font-semibold">
                        <Link
                            :href="route('abouts.index')"
                            class="relative flex items-center rounded-lg border border-cyan-300 bg-cyan-600 px-4 py-2 text-white"
                            aria-label="o nás"
                        >
                            O nás <span aria-hidden="true">&rarr;</span>
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
